import * as _ from 'lodash';

import { getDeliverableProductVideos } from 'app/content/shared/product-video-placeholder.util';

export function styleColorGroupIdForProduct(product: { styleGroupId: string; colorGroupId: string }): string {
    return `${product.styleGroupId}_${product.colorGroupId}`;
}

export function deliverableVideosForMainVariant(mainVariant: { media?: { videos?: unknown[] } } | undefined) {
    return getDeliverableProductVideos(mainVariant?.media?.videos as Parameters<typeof getDeliverableProductVideos>[0]);
}

export function buildProductImageDownloadListItem({
    imageId,
    styleColorGroupId,
    brand,
    brandName,
    articleNumber,
    groupedProducts
}: {
    imageId: string;
    styleColorGroupId: string;
    brand: string;
    brandName: string;
    articleNumber: string;
    groupedProducts: unknown[];
}) {
    return {
        _id: imageId,
        productId: styleColorGroupId + imageId,
        brand: {
            _id: brand,
            name: brandName
        },
        fileId: imageId,
        articleNumber,
        groupedProducts,
        styleColorGroupId
    };
}

export function buildProductVideoDownloadListItem({
    video,
    styleColorGroupId,
    brand,
    brandName,
    articleNumber,
    groupedProducts
}: {
    video: { videoId: string; filename?: string; signedUrl?: string; thumbnailSignedUrl?: string };
    styleColorGroupId: string;
    brand: string;
    brandName: string;
    articleNumber: string;
    groupedProducts: unknown[];
}) {
    return {
        type: 'video' as const,
        _id: video.videoId,
        productId: styleColorGroupId + video.videoId,
        videoId: video.videoId,
        fileId: video.videoId,
        filename: video.filename,
        signedUrl: video.signedUrl,
        thumbnailSignedUrl: video.thumbnailSignedUrl,
        brand: {
            _id: brand,
            name: brandName
        },
        articleNumber,
        groupedProducts,
        styleColorGroupId
    };
}

/** A video row's `fileId` is a PCS `videoId`, not a `media.images._id`, so it must never be sent as a product image. */
export function isDownloadListVideoRow(item: { [key: string]: unknown }): boolean {
    return item.type === 'video' || Boolean(item.videoId);
}

export function downloadListProductIdsForVariant({
    imageIds,
    videos,
    styleColorGroupId
}: {
    imageIds: string[];
    videos: { videoId: string }[];
    styleColorGroupId: string;
}): string[] {
    const imageProductIds = _.map(imageIds, (imageId) => styleColorGroupId + imageId);
    const videoProductIds = _.map(videos, (video) => styleColorGroupId + video.videoId);
    return [...imageProductIds, ...videoProductIds];
}
